<template>
  <div>
    <el-form :inline="true" :model="formInline" ref="formInline" size="mini" class="user-search">
      <!--<el-form-item label="" prop="operatorId">
        <el-select size="mini"
                   clearable
                   filterable
                   @change="stationSelect"
                   v-model="formInline.operatorId"
                   placeholder="运营商"
        >
          <el-option v-for="item in searchData.operators"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-cascader  :model="formInline" placeholder="运营商" size="mini" filterable
                   ref="cascader" clearable
                   :props="{checkStrictly: true,expandTrigger: 'hover'}"
                   :show-all-levels="false"
                   :options="operatorsTree" v-model="operatorIds" @change="handChangeOperator"></el-cascader>
      <el-form-item label="">
        <el-form-item label="">
          <el-select clearable size="mini" v-model="formInline.stationCode" placeholder="充电站">
            <el-option v-for="item in searchData.stationData" :key="item.stationCode" :label="item.stationName" :value="item.stationCode"/>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary"  @click="reset(formInline)">清空</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </el-form-item>
    </el-form>

    <el-container>
      <el-main>
        <!--充电分析-->
        <el-row :gutter="44">
          <el-col :span="24">
            <div class="div_two div_margin">
              <!--<h3 class="h5_style">故障分析</h3>-->
              <!--<div class="st-gbox" style="height: 20vh">
                <div class="div_style_one div_Orange">
                  <div class="fontStyle_three">
                    <div class="fontStyle_one">当日充电订单</div>
                    <div class="fontStyle_two">13</div>
                  </div>
                </div>
                <div class="div_style_one div_Orange">
                  <div class="fontStyle_three">
                    <div class="fontStyle_one">当日充电订单</div>
                    <div class="fontStyle_two">12</div>
                  </div>
                </div>
              </div>-->
              <div class="st-gbox">
                <div class="cavasbox" id="id"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <!--<div :id="id" :class="className" :style="{height:height,width:width}"/>-->
    <!--<div :id="id" :class="className" style="width: 100%;height: 90%;margin-left: 10px;margin-right: 10px;"></div>-->
  </div>
</template>

<script>
  import echarts from 'echarts'
  import commonApi from '@/common/api/commonFromVuexApi.js';
  import api from '@/module/dataCenter/api/alarmRecordStatistic.js';
  import comApi from '@/common/api/commonApi'

  export default {
    data() {
      return {
        operatorsTree:[],
        operatorIds:[],
        chart: null,
        // 选择数据
        selectdata: [],
        // 请求数据参数
        formInline: {
          stationCode:'',
          operatorId:''
        },
        searchData: {
          //站点集合
          stationData: [],
          operators:[]
        },
        alarmRecordStatistic:{
          xaxisData:[],
          yaxisData:{}
        }
      }
    },
    created(){
      this.getData(this.formInline)
      this.getOperators()
      this.getOperatorsTree()
    },
    mounted() {
      this.initChart()
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      getOperatorsTree(){
        let params = JSON.stringify({})
        comApi.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value && value.length > 0 ? value[value.length-1] : ''
        this.formInline.operatorId = operatorId
        this.getStations(operatorId);
        this.$refs.cascader.dropDownVisible = false
      },
      stationSelect(operatorId){
        // 获取指定运营商的站点
        this.getStations(operatorId);
      },
      getStations(operatorId) {
        if (operatorId) {
          const param = {
            operatorId: operatorId
          }
          comApi.getStations(param).then((res) => {
            if (res.data != null && res.data.length > 0) {
              this.searchData.stationData = res.data;
            } else {
              this.searchData.stationData = []
            }
          })
        }
      },
      // 获取运营商
      getOperators() {
        commonApi.getOperators().then(res => {
          this.searchData.operators = res
        })
      },
      reset(){
        this.formInline.operatorId = ''
        this.formInline.stationCode = ''
        this.operatorIds = []
        this.getData(this.formInline)
      },
      search() {
        this.getData(this.formInline)
      },
      getData(parameter) {
        console.log(parameter);
        this.loading = true;
        api.getStatisticData(parameter).then((res) => {
          if(res){
            console.log(res);
            this.alarmRecordStatistic = res;
            this.initChart();
          }
          // 加载结束
          this.loading = false
        }).then(() => {
          this.formInline.id = null
        }).catch(error => {
          this.loading = false;
          this.$message({type: 'error', message: error})
        })
      },
      getStationData(){
        commonApi.getStations().then((res)=>{
          console.log(res);
          this.searchData.stationData = res;
        })
      },
      initChart() {
        this.chart = echarts.init(document.getElementById("id"))
        const xData = (function () {
          const data = []
          for (let i = 1; i < 32; i++) {
            data.push(i + '号')
          }
          return data
        }())
        this.chart.setOption({
          backgroundColor: '#344b58',
          /*title: {
            text: '故障分析',
            x: '20',
            top: '20',
            textStyle: {
              color: '#fff',
              fontSize: '22'
            },
            subtextStyle: {
              color: '#90979c',
              fontSize: '16'
            }
          },*/
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          grid: {
            left: '5%',
            right: '5%',
            borderWidth: 0,
            top: 100,
            bottom: 95,
            textStyle: {
              color: '#fff'
            }
          },
          legend: {
            x: '5%',
            top: '5%',
            textStyle: {
              color: '#90979c'
            },
            data: ['一级故障','二级故障','三级故障','四级故障', '客户上报']
          },
          calculable: true,
          xAxis: [{
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false,
              length: 12,
              inside: true
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            data: this.alarmRecordStatistic.xaxisData
          }],
          yAxis: [{
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            }
          }],
          dataZoom: [{
            show: true,
            height: 20,
            xAxisIndex: [
              0
            ],
            bottom: 30,
            start: 1,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            filterMode: 'empty',
            handleStyle: {
              color: '#d3dee5'
            },
            textStyle: {
              color: '#fff'
            },
            borderColor: '#90979c'

          }, {
            type: 'inside',
            show: true,
            height: 15,
            start: 1,
            end: 35
          }],
          series: [{
            name: '一级故障',
            type: 'line',
            stack: 'total',
            symbolSize: 10,
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: 'rgb(252,29,34)',
                barBorderRadius: 0,
                label: {
                  show: true,
                  position: 'top',
                  formatter(p) {
                    return p.value > 0 ? p.value : ''
                  }
                }
              }
            },
            data: this.alarmRecordStatistic.yaxisData.oneLevelData
          },{
              name: '二级故障',
              type: 'line',
              stack: 'total',
              symbolSize: 10,
              symbol: 'circle',
              itemStyle: {
                normal: {
                  color: 'rgb(252,159,134)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },
              data: this.alarmRecordStatistic.yaxisData.secondLevelData
            }, {
              name: '三级故障',
              type: 'line',
              stack: 'total',
              symbolSize: 10,
              symbol: 'circle',
              itemStyle: {
                normal: {
                  color: 'rgb(190,141,252)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },
              data: this.alarmRecordStatistic.yaxisData.threeLevelData
            },{
              name: '四级故障',
              type: 'line',
              stack: 'total',
              symbolSize: 10,
              symbol: 'circle',
              itemStyle: {
                normal: {
                  color: 'rgba(252,230,48,1)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },
              data: this.alarmRecordStatistic.yaxisData.fourLevelData
            },{
              name: '客户上报',
              type: 'bar',
              stack: 'total',
              itemStyle: {
                normal: {
                  color: 'rgba(0,191,183,1)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },
              data: this.alarmRecordStatistic.yaxisData.customerReportData
            }
          ]
        })
      },
      // 选择复选框事件
      selectChange(val) {
        this.selectdata = val
      }
    }
  }
</script>
<style scoped>
  .div_margin {
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .div_two {
    background-color: white;
  }

  .h5_style {
    text-align: left;
    margin: 0px 0px 10px 5px;
    padding-top: 15px;
  }

  .div_style_one {
    float: left;
    width: 18%;
    height: 60px;
    margin: 0px 10px 10px 0px
  }

  .div_Orange {
    background-color: #ffbc2e;
  }

  .div_red {
    background-color: #FF6640;
  }

  .div_bule {
    background-color: #409EFF;
  }

  .div_green {
    background-color: #43c26e;
  }

  .fontStyle_three {
    margin: 10px 20px 0px 20px;
  }

  .fontStyle_one {
    color: white;
    font-size: small;
  }

  .fontStyle_two {
    color: white;
    font-size: 20px;
    margin-top: 5px;
  }

  .fontStyle_four {
    font-size: small;
  }

  .fontStyle_five {
    font-size: 20px;
    margin-top: 5px;
  }

  .el-header {
    color: #C0C4CC;
    text-align: center;
    line-height: 20px;
  }

  .el-main {
    background-color: #f0f9eb;
    color: #333;
    text-align: center;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .chargestate {
    padding-top: -120px;
  }

  .st-gbox {
    /*background-color: #fff;*/
    margin-top: 20px;
    border-radius: 5px;
    height: 75vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  /*.el-row {*/
  /*margin-bottom: 4px;*/
  /*&:last-child {*/
  /*margin-bottom: 0;*/
  /*}*/
  /*}*/
  .grid-content {
    border-radius: 2px;
    min-height: 28px;
    line-height: 28px;
    text-align: left;
    font-size: small;
    color: #606266;
    padding-left: 10px;
  }

  /deep/ .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/alarmAnalyse/alarmRecordStatistic.vue